import { render, staticRenderFns } from "./Simple3.vue?vue&type=template&id=5ad6a6b2&"
import script from "./Simple3.vue?vue&type=script&lang=js&"
export * from "./Simple3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports